import { createRoot } from "react-dom/client";
import { FaCheck, FaQuestionCircle, FaTimes, FaTimesCircle, FaExclamationCircle } from "react-icons/fa";
import Button from "../controls/button/button";
import ActionButton from "../controls/action-button/ActionButton";
import Column from "../layout/column/column";
import Dialog from "./dialog";

/**
 * Dialog boxes manager.
 */
class Dialogs {
  static createRoot(component) {
    // Create values div
    const bg = document.createElement("div");
    bg.classList.add("dialog-bg");

    // Create react root
    const bgRoot = createRoot(bg);

    // Add options
    bgRoot.render(component);

    // Add values to body
    document.body.querySelector(".App").append(bg);

    // Return background component
    return bg;
  }
  static alert(message, title, onOk) {
    const bg = Dialogs.createRoot(
      <Dialog
        title={title}
        message={message}
        buttons={
          <Column>
            <Button
              small
              onClick={() => {
                bg.remove();
                onOk?.();
              }}
            >
              Ok
            </Button>
          </Column>
        }
      />
    );
  }
  static confirm(message, title, onYes, onNo) {
    const bg = Dialogs.createRoot(
      <Dialog
        icon={<FaExclamationCircle style={{ width: "34px", height: "34px", color: "#f87171" }} />}
        title={title}
        message={message}
        buttons={
          <>
            <Column>
              <ActionButton
                onClick={() => {
                  bg.remove();
                  onYes?.();
                }}
                icon={FaCheck}
                title="Oui"
                subtitle="Confirmer l'action"
                colors={{
                  primary: "#11998e",
                  secondary: "#0d7377",
                  shadow: "rgba(17, 153, 142, 0.4)",
                  shadowHover: "rgba(17, 153, 142, 0.6)",
                }}
                decorativeIcon={{ type: "validate" }}
                style={{ width: "180px" }}
              />
            </Column>
            <Column lpad>
              <ActionButton
                onClick={() => {
                  bg.remove();
                  onNo?.();
                }}
                icon={FaTimes}
                title="Non"
                subtitle="Annuler l'action"
                colors={{
                  primary: "#e57373",
                  secondary: "#c62828",
                  shadow: "rgba(229, 115, 115, 0.4)",
                  shadowHover: "rgba(229, 115, 115, 0.6)",
                }}
                decorativeIcon={{ type: "cancel" }}
                style={{ width: "180px" }}
              />
            </Column>
          </>
        }
      />
    );
  }
  static error(message, title, onOk) {
    const bg = Dialogs.createRoot(
      <Dialog
        title={title}
        message={message}
        buttons={
          <Column>
            <ActionButton
              onClick={() => {
                bg.remove();
                onOk?.();
              }}
              icon={FaCheck}
              title="Valider"
              //   subtitle="Fermer ce message"
              colors={{
                primary: "#11998e",
                secondary: "#0d7377",
                shadow: "rgba(17, 153, 142, 0.4)",
                shadowHover: "rgba(17, 153, 142, 0.6)",
              }}
              decorativeIcon={{ type: "validate" }}
              style={{ width: "180px" }}
            />
          </Column>
        }
      />
    );
  }
}
export default Dialogs;
